/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChartPie = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M11 6v7h7v1a8 8 0 1 1-8-8zm-1 9.414-3.476 3.477A5.973 5.973 0 0 0 10 20c1.296 0 2.496-.41 3.477-1.11zm-1-7.33-.102.017a6.002 6.002 0 0 0-3.79 9.375L9 13.584zM15.915 15h-3.5l2.477 2.475a5.971 5.971 0 0 0 .96-2.142l.047-.23zM14 2a8 8 0 0 1 8 8v1h-9V2zm1 2.084V9h4.915l-.016-.102A6.006 6.006 0 0 0 15.102 4.1z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgChartPie as ChartPie };
